import { useEffect, useMemo } from 'react'
import { z } from 'zod'

import { useMe } from '@/hooks/features/user/me.altair'
import { useUpdateLanguage } from '@/hooks/features/user/updateLanguage'
import i18n from '@/lib/i18n'

import { Language } from '../../i18n'

const schema = z.enum(['ja', 'en'])

export const useLanguage = () => {
  const { data: user } = useMe({})
  const { mutateAsync: updateLanguage } = useUpdateLanguage({})

  const preferredLanguage = user?.preferredLanguage

  const language = useMemo((): Language => {
    if (preferredLanguage) {
      return preferredLanguage
    }
    try {
      return schema.parse(i18n.language)
    } catch {
      return 'ja'
    }
  }, [preferredLanguage])

  useEffect(() => {
    if (!preferredLanguage || i18n.language === preferredLanguage) {
      return
    }

    let cancelled = false

    const syncLanguage = async () => {
      await i18n.changeLanguage(preferredLanguage)

      if (cancelled) {
        return
      }

      window.location.reload()
    }

    void syncLanguage()

    return () => {
      cancelled = true
    }
  }, [preferredLanguage])

  const changeLanguage = async (language: Language) => {
    await updateLanguage(language)
    await i18n.changeLanguage(language)

    window.location.reload()
  }

  return { language, changeLanguage }
}
